export default __webpack_public_path__ + "static/media/chatbot-agent-icon.85559231.png";